import { apiGet } from '../axios.config'
import { API_ROUTES } from '../routes'
import { AgreementStatus, Product } from '../typing'
import { useQueryHook } from './queryHook'

interface IBaseAgreementResponse {
  id: string
  createdAt: string
}

interface IUserAgreementResponse extends IBaseAgreementResponse {
  name: string
  signedAt: string
  isSigned: boolean
  agreementHtml: string
}

interface IAdminAgreementResponse extends IUserAgreementResponse {
  authorId: string
  authorPhone: string
  status: AgreementStatus
  typeId: string
  typeName: string
  substitutions: {
    [key: string]: string
  }
  products: Product[]
}

const useBaseAgreement = <T extends IBaseAgreementResponse>(path: string, id: string) => {
  const queryObject = useQueryHook({
    key: [path, id],
    fetcherFunction: async () => {
      const { data } = await apiGet<object, T>({ path, params: { id } })

      return data
    },
  })

  return {
    ...queryObject,
    data: queryObject.data as T | null,
  }
}

export const useGetViewDataAgreement = (id: string) =>
  useBaseAgreement<IUserAgreementResponse>(API_ROUTES.AGREEMENT_GET, id)

export const useGetEditDataAgreement = (id: string) =>
  useBaseAgreement<IAdminAgreementResponse>(API_ROUTES.AGREEMENT_ADMIN_GET, id)
